import React from 'react';

import { DiffSet, DiffSetProps } from 'src/components/diff-set/diff-set';

const DiffSetWithPageLoad = (props: DiffSetProps) => {
  return <DiffSet {...props} />;
};

export default DiffSetWithPageLoad;
